module.exports = __webpack_public_path__ + "static/img/automate.8a07953.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/automate.jpeg
// module id = NWg+
// module chunks = 7